import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';

const theme = createTheme({
  palette: {
    primary: {
      main: '#b45309',
      light: '#d97706',
      dark: '#92400e',
    },
    secondary: {
      main: '#0f766e',
    },
    background: {
      default: '#faf6f0',
      paper: '#fffefb',
    },
    text: {
      primary: '#431407',
      secondary: '#78716c',
    },
  },
  typography: {
    fontFamily: '"Nunito Sans", system-ui, sans-serif',
    h4: { fontFamily: '"Cormorant Garamond", Georgia, serif', fontWeight: 700 },
    h5: { fontFamily: '"Cormorant Garamond", Georgia, serif', fontWeight: 700 },
    h6: { fontFamily: '"Cormorant Garamond", Georgia, serif', fontWeight: 700 },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 700 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(67, 20, 7, 0.06)',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
